import React from 'react';
import { useLocation } from 'react-router-dom';
import { HTMLContent } from '../../../../common/components/html-content';

export default function Inbox() {
    const location = useLocation();
    const Inbox = location.state;

    return (
        <div className="max-w-6xl mx-auto px-4 py-8">
            <div className="bg-white shadow-md rounded-lg p-6 mb-6">
                <div className="text-3xl font-bold text-gray-800 mb-2">{Inbox.Subject || 'No Subject'}</div>
                <div className="text-sm text-gray-500">
                    <span className="block">From: <strong>{Inbox.FromEmailId}</strong></span>
                    <span className="block">To: <strong>{Inbox.Email}</strong></span>
                    <span className="block mt-1">{new Date(Inbox.LastReceivedOnUtc).toLocaleString()}</span>
                </div>
            </div>

            <div className="bg-white shadow-md rounded-lg p-6 mb-6">
                <div className="flex items-center text-xl font-semibold text-gray-800 mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#e69005" fill="none">
                        <path d="M2 6L8.91302 9.91697C11.4616 11.361 12.5384 11.361 15.087 9.91697L22 6" stroke="#e69005" stroke-width="1.5" stroke-linejoin="round"></path>
                        <path d="M2.01577 13.4756C2.08114 16.5412 2.11383 18.0739 3.24496 19.2094C4.37608 20.3448 5.95033 20.3843 9.09883 20.4634C11.0393 20.5122 12.9607 20.5122 14.9012 20.4634C18.0497 20.3843 19.6239 20.3448 20.7551 19.2094C21.8862 18.0739 21.9189 16.5412 21.9842 13.4756C22.0053 12.4899 22.0053 11.5101 21.9842 10.5244C21.9189 7.45886 21.8862 5.92609 20.7551 4.79066C19.6239 3.65523 18.0497 3.61568 14.9012 3.53657C12.9607 3.48781 11.0393 3.48781 9.09882 3.53656C5.95033 3.61566 4.37608 3.65521 3.24495 4.79065C2.11382 5.92608 2.08114 7.45885 2.01576 10.5244C1.99474 11.5101 1.99475 12.4899 2.01577 13.4756Z" stroke="#e69005" stroke-width="1.5" stroke-linejoin="round"></path>
                    </svg> Message</div>
                <div className="text-gray-700 text-base leading-relaxed">
                    <HTMLContent htmlContent={Inbox.Message} />
                </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div className="bg-gray-50 border rounded-lg p-5">
                    <h3 className="text-lg font-medium text-gray-700">Sender Details</h3>
                    <ul className="mt-3 space-y-1 text-sm text-gray-600">
                        <li><strong>Name:</strong> {Inbox.FirstName} {Inbox.LastName}</li>
                        <li><strong>Email:</strong> {Inbox.FromEmailId}</li>
                        <li><strong>Phone:</strong> {Inbox.Phone || 'N/A'}</li>
                        <li><strong>Username:</strong> {Inbox.UserName || 'N/A'}</li>
                    </ul>
                </div>

                <div className="bg-gray-50 border rounded-lg p-5">
                    <h3 className="text-lg font-medium text-gray-700">Message Metadata</h3>
                    <ul className="mt-3 space-y-1 text-sm text-gray-600">
                        <li><strong>Received On:</strong> {new Date(Inbox.LastReceivedOnUtc).toLocaleString()}</li>

                    </ul>
                </div>
            </div>
        </div>
    );
}
